import { logoDantasEletroBase64 } from '../assets/logoDantasEletro';

// Gera o HTML do Contrato de Compra e Venda com Reserva de Domínio.
// Usado tanto na emissão original (AnaliseCredito.jsx) quanto na reimpressão
// a partir do histórico (HistoricoAnalises.jsx) — o texto e o layout são
// sempre os mesmos, apenas os dados (cliente, valores, data) mudam.
export function gerarHtmlContrato({
  cliente,
  dataContrato,
  valorTotal,
  numParcelas,
  valorEntrada,
  nomeOperador,
}) {
  const dataExtenso = dataContrato.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
  const parcelas = Number(numParcelas) || 1;
  const entrada = Number(valorEntrada) || 0;
  const valorFinanciado = Number(valorTotal) - entrada;
  const valorParcela = parcelas > 0 ? valorFinanciado / parcelas : valorFinanciado;

  // Gera linhas da tabela de parcelas (máx 12 no layout), vencimentos a partir da data do contrato
  const linhasParcelas = Array.from({ length: Math.min(parcelas, 12) }, (_, i) => {
    const venc = new Date(dataContrato);
    venc.setMonth(venc.getMonth() + i + 1);
    return `<tr>
      <td style="border:1px solid #aaa;padding:2px 6px;font-size:11px">${String(i + 1).padStart(2, '0')}</td>
      <td style="border:1px solid #aaa;padding:2px 6px;font-size:11px">R$ ${valorParcela.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
      <td style="border:1px solid #aaa;padding:2px 6px;font-size:11px">${venc.toLocaleDateString('pt-BR')}</td>
    </tr>`;
  }).join('');

  const totalRestante = parcelas > 12 ? `<p style="font-size:11px;margin-top:4px">+ ${parcelas - 12} parcelas restantes de R$ ${valorParcela.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} cada</p>` : '';

  const cpfOuCnpj = cliente?.CPF
    ? `CPF: ${cliente.CPF}`
    : cliente?.CNPJ
    ? `CNPJ: ${cliente.CNPJ}`
    : '';

  const endereco = [cliente?.Endereco, cliente?.Numero, cliente?.Bairro, cliente?.Cidade, cliente?.Estado]
    .filter(Boolean).join(', ');

  return `
    <!DOCTYPE html>
    <html>
    <head>
    <title>Contrato de Compra e Venda - ${cliente?.Nome ?? ''}</title>
    <style>
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: Arial, sans-serif; font-size: 11px; color: #111; padding: 18px 22px; }
        .header-topo { display: flex; align-items: center; justify-content: space-between; border: 2px solid #003399; padding: 6px 10px; margin-bottom: 0; }
        .header-topo .logo-img { height: 48px; display: block; }
        .titulo-contrato { background: #003399; color: #fff; text-align: center; font-size: 13px; font-weight: 700; padding: 4px; letter-spacing: 1px; text-transform: uppercase; }
        .subtitulo { text-align: center; font-size: 9px; border: 1px solid #003399; border-top: 0; padding: 3px 6px; margin-bottom: 6px; }
        .campos-topo { display: grid; grid-template-columns: 1fr 1fr; gap: 0; border: 1px solid #999; margin-bottom: 6px; }
        .campo { border: 1px solid #bbb; padding: 3px 6px; min-height: 22px; }
        .campo label { font-size: 8px; color: #555; display: block; font-weight: 700; text-transform: uppercase; }
        .campo span { font-size: 11px; font-weight: 600; }
        .corpo { font-size: 8.5px; line-height: 1.45; text-align: justify; margin-bottom: 6px; border: 1px solid #bbb; padding: 4px 8px; }
        .corpo p { margin-bottom: 1px; }
        .corpo strong { font-weight: 700; }
        .layout-baixo { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 6px; }
        .assinaturas { border: 1px solid #bbb; padding: 6px 8px; }
        .linha-ass { border-top: 1px solid #111; margin-top: 28px; padding-top: 3px; font-size: 10px; text-align: center; }
        .tabela-parcelas { border: 1px solid #bbb; padding: 6px 8px; }
        .tabela-parcelas h4 { font-size: 11px; font-weight: 700; text-align: center; margin-bottom: 5px; text-transform: uppercase; letter-spacing: 1px; }
        table.parcelas { width: 100%; border-collapse: collapse; }
        table.parcelas th { background: #eee; font-size: 10px; border: 1px solid #aaa; padding: 3px 6px; }
        .nota-promissoria { border: 2px solid #003399; margin-top: 6px; padding: 8px 10px; font-size: 10px; }
        .nota-promissoria .titulo-np { font-weight: 700; font-size: 11px; text-align: center; letter-spacing: 2px; text-transform: uppercase; margin-bottom: 6px; }
        .linha-np { border-top: 1px solid #555; margin-top: 12px; padding-top: 3px; font-size: 9px; }
        .rodape-liberacao { margin-top: 18px; padding-top: 10px; border-top: 1px dashed #aaa; font-size: 10px; }
        .rodape-liberacao .linha-ass-lib { border-top: 1px solid #111; width: 260px; margin: 24px 0 3px 0; padding-top: 3px; font-size: 10px; }
        @media print { body { padding: 8px; } button { display: none !important; } }
    </style>
    </head>
    <body>

    <!-- Cabeçalho -->
    <div class="header-topo">
        <img class="logo-img" src="${logoDantasEletroBase64}" alt="Dantas Eletro">
        <div style="text-align:right;font-size:10px;color:#555">
        CNPJ: 11.684.503/0001-40<br>
        Rua Monsenhor Salviano Pinto, 575<br>
        Quixeramobim – CE
        </div>
    </div>
    <div class="titulo-contrato">Contrato de Compra e Venda com Reserva de Domínio</div>
    <div class="subtitulo">
        MARIA EDITE RAFAEL DANTAS (DANTAS ELETRO) — CNPJ 11.684.503/0001-40 — Quixeramobim-CE
    </div>

    <!-- Campos do cliente -->
    <div class="campos-topo">
        <div class="campo" style="grid-column:1/2">
        <label>Cliente</label>
        <span>${cliente?.Nome ?? ''}</span>
        </div>
        <div class="campo" style="grid-column:2/3">
        <label>Identificação (CPF/CNPJ/RG)</label>
        <span>${cpfOuCnpj || cliente?.RG_IE || ''}</span>
        </div>
        <div class="campo" style="grid-column:1/2">
        <label>Endereço</label>
        <span>${endereco}</span>
        </div>
        <div class="campo" style="grid-column:2/3">
        <label>Cidade</label>
        <span>${[cliente?.Cidade, cliente?.Estado].filter(Boolean).join(' – ')}</span>
        </div>
    </div>

    <!-- Cláusulas -->
    <div class="corpo">
        <p>Neste ato denominado doravante <strong>CLIENTE</strong>, tem entre si certo e ajustado o presente contrato de novação a prazo que obedecerá às seguintes cláusulas e condições.</p>
        <p><strong>01-</strong> A VENDEDORA vendeu ao CLIENTE a(s) mercadoria(s) deste contrato que para todos os efeitos declaro ter recebido em perfeita ordem, a preço certo e ajustado conforme demonstração no verso.</p>
        <p><strong>02-</strong> O local de pagamento será o endereço da VENDEDORA ou outro indicado.</p>
        <p><strong>03-</strong> O CLIENTE se compromete: A) pagar as parcelas nos respectivos vencimentos; B) não alienar, ou por qualquer modo ceder ou transferir a terceiros o(s) bem(ns) deste contrato; C) manter o(s) bem(ns) em condições de boa conservação e funcionamento.</p>
        <p><strong>04-</strong> O valor do débito é representado por promissória(s) e as prestações serão pagas através de quitação das referidas promissórias ou carnês que será autenticado no ato do pagamento.</p>
        <p><strong>05-</strong> Mesmo na hipótese de caso fortuito ou força maior, os quais, desde já eliminados por ambos contratantes e respectivos AVALISTAS responderão a VENDEDORA e CLIENTE pelo integral cumprimento deste contrato, inclusive o AVALISTA como obrigado solidário e principal pagador.</p>
        <p><strong>06-</strong> Por ser a presente venda feita a prazo, fica reservado a VENDEDORA a propriedade a(s) mercadoria(s) constante na cláusula 1, obrigando-se o CLIENTE a mantê-la(s) até liquidação total do contrato, com a responsabilidade de fiel depositário e, após o resgate total da dívida, o CLIENTE adquirirá o pleno domínio da(s) mercadoria(s), independente de quaisquer formalidade.</p>
        <p><strong>07-</strong> A falta de pagamento quaisquer da(s) parcela(s) do contrato, concede a VENDEDORA o direito de ingressar com pedido de busca e apreensão da(s) mercadoria(s) da cláusula 1.</p>
        <p><strong>08-</strong> A devolução do(s) bem(s), constante(s) da cláusula 1 à VENDEDORA, não significa quitação da dívida, se houver descumprimento da cláusula 3, letra C.</p>
        <p><strong>09-</strong> Ocorrendo um atraso superior a 10 dias no pagamento de uma prestação, será cobrada do comprador uma taxa de 5% ao mês sobre o valor da prestação, a título de despesas de cobrança.</p>
        <p><strong>10-</strong> Se, para defesa de seus direitos decorrentes do presente contrato, precisar a VENDEDORA recorrer a meios judiciais, correrão por conta do CLIENTE todas as despesas processuais mais os honorários de advogados, desde já estipulado em 20% sobre o valor da causa.</p>
        <p><strong>11-</strong> PROTEÇÃO DE DADOS (Lei 13.709/2018): o CLIENTE está ciente de que seus dados pessoais, cópia de documentos e fotografia são tratados somente para análise de crédito, identificação, prevenção a fraudes, execução e cobrança deste contrato (arts. 7º, V, VI e X, e 11, II, "g"), compartilhados apenas com órgãos de proteção ao crédito e por obrigação legal, e guardados por até 6 anos, quando serão eliminados. O CLIENTE pode pedir na loja acesso, correção e revisão da decisão de crédito.</p>
        <p><strong>12-</strong> Fica eleito o Fórum desta cidade como competente para qualquer ação oriunda do presente contrato. E por estarem de comum acordo sobre todas as cláusulas, assinam o presente em 1 (uma) via para os efeitos legais.</p>
    </div>

    <!-- Assinaturas + Tabela de parcelas -->
    <div class="layout-baixo">

        <!-- Assinaturas -->
        <div class="assinaturas">
        <div style="font-size:10px;margin-bottom:4px"><strong>Local e Data:</strong> Quixeramobim, Ceará, ${dataExtenso}</div>
        <div class="linha-ass">${cliente?.Nome ?? 'Cliente'} (Cliente)</div>
        <div class="linha-ass">Testemunha: _______________________________</div>
        <div class="linha-ass">Avalista: _______________________________</div>
        <div class="linha-ass">Vendedor(a): _______________________________</div>
        <div class="linha-ass">Responsável pela Liberação: ${nomeOperador ?? ''}</div>
        </div>

        <!-- Tabela de parcelas -->
        <div class="tabela-parcelas">
        <h4>Prestações (R$) — Vencimentos</h4>
        ${entrada > 0 ? `<p style="font-size:10px;margin-bottom:5px">Entrada: <strong>R$ ${entrada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>` : ''}
        <table class="parcelas">
            <thead>
            <tr>
                <th>Nº</th>
                <th>Valor (R$)</th>
                <th>Vencimento</th>
            </tr>
            </thead>
            <tbody>
            ${linhasParcelas}
            </tbody>
        </table>
        ${totalRestante}
        <p style="font-size:10px;margin-top:6px;font-weight:700">Total financiado: R$ ${valorFinanciado.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
        </div>
    </div>

    <!-- Nota Promissória -->
    <div class="nota-promissoria">
        <div class="titulo-np">Nota Promissória</div>
        <div style="display:grid;grid-template-columns:auto 1fr auto;gap:8px;align-items:end">
        <div><strong>Nº</strong> _____________</div>
        <div><strong>Vencimento em</strong> _____ / _____ / _______</div>
        <div><strong>R$</strong> ___________________</div>
        </div>
        <p style="margin-top:8px">No dia ______ PAGAREI (EMOS) POR ESTA NOTA A <strong>MARIA EDITE RAFAEL DANTAS (DANTAS ELETRO)</strong> C.N.P.J.: 11.684.503/0001-40 OU A SUA ORDEM A QUANTIA DE _______________________________________________</p>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:10px">
        <div>
            <div class="linha-np">Emitente: ${cliente?.Nome ?? ''}</div>
            <div class="linha-np">CPF/CNPJ: ${cpfOuCnpj || ''}</div>
            <div class="linha-np">Endereço: ${endereco}</div>
        </div>
        <div style="text-align:right">
            <div class="linha-np">Local e Data: Quixeramobim – CE, ${dataExtenso}</div>
        </div>
        </div>
    </div>

    <script>window.onload = () => window.print();</script>
    </body>
    </html>
  `;
}
